<i18n>
{
  "no": {
    "ACCOUNT_MISSING_EMAIL": "Kontoen mangler epostadresse",
    "ACCOUNT_MISSING_MOBILE": "Kontoen mangler mobilnummer",
    "TITLE" : "Glemt brukernavn",
    "SEND_IT": "Send meg brukernavnet",
    "SUCCESS": "Brukernavnet er sent til kontaktinformasjonen du oppga. Gå tilbake til",
    "LOGIN": "innlogging"
  },
  "en": {
    "ACCOUNT_MISSING_EMAIL": "User account has no email address",
    "ACCOUNT_MISSING_MOBILE": "User account has no mobile number",
    "TITLE" : "Forgot user name",
    "SEND_IT": "Send me the username",
    "SUCCESS": "The user name was sent. Go back to ",
    "LOGIN": "login"
  }
}
</i18n>

<template>
  <div class="page">
    <FormWrapper>
      <div>
        <TnHeading type="h1" size="l" align="center" class="margin-vertical-2xl">
          {{ t('TITLE') }}
        </TnHeading>

        <ErrorMessage :error="error" />

        <form v-if="state === 'input'" method="post" @submit.prevent="onSubmit">
          <div class="field-stack">
            <TnTextField
              v-model="model.firstName"
              name="firstName"
              required
              :label="t('fields.firstName')"
              :placeholder="t('fields.firstName')"
            />
            <TnTextField
              v-model="model.middleName"
              name="middleName"
              :label="t('fields.middleName')"
              :placeholder="t('fields.middleName')"
            />
            <TnTextField
              v-model="model.lastName"
              name="lastName"
              required
              :label="t('fields.lastName')"
              :placeholder="t('fields.lastName')"
            />
            <TnTextField
              v-model="model.birthday"
              name="birthday"
              required
              :label="t('fields.birthday')"
              placeholder="2000-04-27"
            />
            <TnTextField
              v-model="model.zipCode"
              name="zipCode"
              required
              :label="t('fields.zipCode')"
              placeholder="1234"
            />
            <TnTextField
              v-model="model.mobile"
              name="phone"
              type="tel"
              :label="t('fields.phone')"
              placeholder="+4755555555"
            />
            <TnTextField
              v-model="model.email"
              name="email"
              type="email"
              :label="t('fields.email')"
              placeholder="oda@nordmann.no"
            />
          </div>

          <TnButton type="submit" primary block class="margin-top-l" :text="t('SEND_IT')" />
        </form>

        <TnParagraph v-else-if="state === 'sent'" size="s">
          {{ t('SUCCESS') }}
          <TnLink :to="{ name: 'elv-login', query: { request } }" :text="t('LOGIN')" />
        </TnParagraph>
      </div>
    </FormWrapper>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import {
  TnButton,
  TnHeading,
  TnLink,
  TnParagraph,
  TnTextField,
} from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from '@/components/FormWrapper.vue';
import ErrorMessage from '@/views/elvis/components/errorMessage.vue';
import { forgotUsername } from '../api';

const { t } = useI18n();
const route = useRoute();

const state = ref<'input' | 'sent'>('input');
const error = ref<unknown>(null);

const model = reactive({
  firstName: '',
  middleName: '',
  lastName: '',
  birthday: '',
  zipCode: '',
  mobile: '',
  email: '',
});

// Was `params: { query: request }`, which never reached the login view's query.
const request = computed(() => (route.query.request as string) || '');

function onSubmit() {
  error.value = null;
  forgotUsername({ ...model, phone: model.mobile })
    .then(() => (state.value = 'sent'))
    .catch((err) => (error.value = err));
}
</script>
